import { axiosWithAuth } from "helpers";
import { UnderwritingTabs } from "types/enums";

export const merchantInfoService = {
	editIsDailyDiscount,
	editMccField,
	editProcessorField,
	editSponsorField,
	editTaxIdField,
	getMerchantInformation,
	saveHighRiskMarker,
	saveResiduals,
	saveUnderwritingCardInfo,
	underwritingApprove,
	underwritingDecline,
	updateUnderwritingApproval,
	viewFullAppDocument,
};

const API_URL = process.env.REACT_APP_API_URL;

function getMerchantInformation(applicationId, tab) {
	let correctedTab = tab;

	if (
		[
			UnderwritingTabs.Unassigned.name,
			UnderwritingTabs.InReview.name,
		].includes(tab)
	) {
		correctedTab = "open";
	} else if (tab === UnderwritingTabs.Concurrence.name) {
		correctedTab = "concurrence";
	} else if (tab === UnderwritingTabs.QAUnassigned.name) {
		correctedTab = "qaUnassigned";
	} else if (tab === UnderwritingTabs.QAInProgress.name) {
		correctedTab = "qaInProgress";
	} else if (tab === UnderwritingTabs.QAComplete.name) {
		correctedTab = "qaCompleted";
	}
	const options = {
		method: "GET",
		params: {
			applicationId,
			tab: correctedTab,
		},
		url: `${API_URL}/api/underwriting/merchant_information`,
	};

	return axiosWithAuth(options);
}

function viewFullAppDocument(applicationId) {
	let user = JSON.parse(localStorage.getItem("user"));
	window.open(
		`${API_URL}/api/applications/${applicationId}/view-full?token=${user.access_token}`,
		"_blank",
	);
}

function underwritingDecline({ applicationId, decision }) {
	const options = {
		url: `${API_URL}/api/underwriting/applications/${applicationId}/reject`,
		method: "POST",
		data: decision,
	};

	return axiosWithAuth(options);
}

function underwritingApprove({ applicationId, decision }) {
	const options = {
		method: "POST",
		data: decision,
		url: `${API_URL}/api/underwriting/applications/${applicationId}/approve`,
	};

	return axiosWithAuth(options);
}

function updateUnderwritingApproval({ applicationId, decision }) {
	const options = {
		method: "POST",
		data: decision,
		url: `${API_URL}/api/underwriting/applications/${applicationId}/update_approval`,
	};

	return axiosWithAuth(options);
}

function editMccField(applicationId, mccCode, merchantDescription, mccAliasId) {
	const options = {
		method: "POST",
		data: {
			mcc: mccCode,
			what_do_you_sell: merchantDescription,
			mcc_alias_id: mccAliasId,
		},
		url: `${API_URL}/api/underwriting/applications/${applicationId}/change_mcc`,
	};

	return axiosWithAuth(options);
}

function editTaxIdField(applicationId, taxId) {
	const options = {
		method: "POST",
		data: {
			tax_id: taxId,
		},
		url: `${API_URL}/api/underwriting/applications/${applicationId}/change_tax_id`,
	};

	return axiosWithAuth(options);
}

function editSponsorField(applicationId, sponsorId) {
	const options = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: {
			sponsor_id: sponsorId,
		},
		url: `${API_URL}/api/underwriting/applications/${applicationId}/change_sponsor`,
	};

	return axiosWithAuth(options);
}

function editProcessorField(applicationId, processorId) {
	const options = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: {
			processor_id: processorId,
		},
		url: `${API_URL}/api/underwriting/applications/${applicationId}/change_processor`,
	};

	return axiosWithAuth(options);
}
function saveUnderwritingCardInfo({ merchantInfo, applicationId }) {
	const options = {
		method: "POST",
		data: merchantInfo,
		url: `${API_URL}/api/underwriting/applications/${applicationId}/underwriting_info`,
	};

	return axiosWithAuth(options);
}

function saveResiduals(
	applicationId,
	{ scheduleAId = "", splitProfileId = "" },
) {
	const options = {
		method: "POST",
		data: {
			schedule_a_id: scheduleAId ? scheduleAId : undefined,
			split_profile_id: splitProfileId ? splitProfileId : undefined,
		},
		url: `${API_URL}/api/underwriting/${applicationId}/residuals`,
	};

	return axiosWithAuth(options);
}

function saveHighRiskMarker(applicationId, isHighRisk) {
	const options = {
		method: "POST",
		data: isHighRisk,
		url: `${API_URL}/api/underwriting/${applicationId}/residuals/change_high_risk`,
	};

	return axiosWithAuth(options);
}

function editIsDailyDiscount(applicationId, isDailyDiscount) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/underwriting/applications/${applicationId}/change_is_daily_discount`,
		params: {
			is_daily_discount: isDailyDiscount,
		},
	};

	return axiosWithAuth(options);
}
